module.exports = __webpack_public_path__ + "f64dfc348a23c4fc8f6dbfede3099c25.svg";